import React, {useState} from "react";
import {NavLink, useNavigate} from "react-router-dom";
import {MdDashboard, MdKeyboardArrowDown, MdKeyboardArrowUp} from "react-icons/md";
import {FaBorderTopLeft, FaCartShopping} from "react-icons/fa6";
import {FaSolarPanel} from "react-icons/fa";
import {Can} from "../../Can";

const PanelDropdownSidebar = ({thememode}) => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const handleMainClick = () => {
        // Navigate to the default dashboard page
        navigate("/PanelsManagement");
    };

    const handleArrowClick = (e) => {
        e.stopPropagation(); // Prevent triggering the main click
        setIsOpen(!isOpen);
    };

    return (
        <div className="mb-1">
            <div
                className={`flex items-center justify-between p-3 pl-6 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300`}
                onClick={handleMainClick}
            >
                <div className={'flex items-center '}>
                    <FaSolarPanel className="mr-3"/>
                    <span className="flex-grow">Panels</span>
                </div>
                <div
                    className="p-1 hover:bg-gray-300 dark:hover:bg-gray-600 rounded"
                    onClick={handleArrowClick}
                >
                    {isOpen ? <MdKeyboardArrowUp/> : <MdKeyboardArrowDown/>}
                </div>
            </div>

            {isOpen && (
                <div>
                    <Can I="index" a="panels">
                    <NavLink
                        to="/Panels"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Panels</span>
                    </NavLink>
                    </Can>

                    <Can I="update" a="panels">
                    <NavLink
                        to="/Panels/UpdatedPanels"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Updated Panels</span>
                    </NavLink>
                    </Can>
                    <Can I="store" a="panels">
                    <NavLink
                        to="/Panels/Add"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Add Panel</span>
                    </NavLink>
                    </Can>
                    <Can I="index" a="categories">
                    <NavLink
                        to="/Categories"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Service Categories</span>
                    </NavLink>
                    </Can>
                    <Can I="index" a="subcategories">
                    <NavLink
                        to="/SubCategories"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Sub Categories</span>
                    </NavLink>
                    </Can>
                    <Can I="index" a="panelsReviews">
                    <NavLink
                        to="/Reviews/Panels"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Panel Reviews</span>
                    </NavLink>
                    </Can>
                    <Can I="index" a="servicesreviews">
                    <NavLink
                        to="/Reviews/Services"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Service Reviews</span>
                    </NavLink>
                    </Can>

                </div>
            )}
        </div>
    );
};

export default PanelDropdownSidebar;